<template>
  <div class="section-main__warp work-order work-order-detail">
    <div class="main-content">
      <div class="header">
        <div class="tabs">
           <div class="tab"
               @click.stop="$router.go(-1);">返回</div>
          <div :class="['tab', index === 0 ? 'active' : '']"
               @click.stop="switchTab(0)">{{$t('workOrder.title.createTable')}}</div>
          <div :class="['tab', index === 1 ? 'active' : '']"
               v-if="workOrderType!=2"
               @click.stop="switchTab(1)">{{$t('workOrder.title.createFlow')}}</div>
         
        </div>
      </div>
      <field-list :workOrderType="workOrderType"
                  v-if="index === 0"></field-list>
      <workflow v-else></workflow>
    </div>
  </div>
</template>

<script>
import { api } from '../api'
import fieldList from '../components/field-list'
import workflow from '../components/workflow'
import utils from '@src/common/utils'
export default {
  components: {
    fieldList,
    workflow
  },
  data () {
    return {
      index: 0,
      workOrderType: 0
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.index) {
      this.index = Number(this.$route.query.index)
    }
    if (this.$route.query && this.$route.query.workOrderType) {
      this.workOrderType = Number(this.$route.query.workOrderType)
    }
  },
  methods: {
    switchTab (i) {
      this.index = i;
    }
  }
}
</script>

<style>
</style>